import { Inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { Store } from '@ngxs/store';

import { AUTH_TOKEN } from '@recruitee/common';

import { ICoreState } from '../../core/state/core.interfaces';
import { CoreState } from '../../core/state/core.state';

@Injectable({ providedIn: 'root' })
export class AuthenticatedUserGuard implements CanActivate {
  constructor(
    @Inject(AUTH_TOKEN) private token: string,
    private router: Router,
    private store: Store,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const coreState = this.store.selectSnapshot<ICoreState>(CoreState);
    const isAuthenticatedUser = this.token && !coreState.isForeignAdmin;

    return isAuthenticatedUser || this.router.createUrlTree(['/auth/sign_in']);
  }
}
